import {
  EntityId,
  IAction,
  IProcessedEvent,
  TRANSFER_TYPE,
} from '@shared/types';
import { EventsActions } from '@store/actions';
import { filter, includes } from 'lodash';

export type PopulateEvent = {
  [key in TRANSFER_TYPE]: EntityId;
};

export interface IEventState {
  list: IProcessedEvent[];
  selectedEvents: IProcessedEvent[];
  selectedEventIds: string[];
  newTransferAutoPopulateEvent: Partial<PopulateEvent>;
  incompleteTransferSelectedEvents: IProcessedEvent;
}

const INITIAL_STATE: IEventState = {
  list: [],
  selectedEvents: [],
  selectedEventIds: [],
  newTransferAutoPopulateEvent: {},
  incompleteTransferSelectedEvents: null,
};

export const eventsReducer = (
  state: IEventState = INITIAL_STATE,
  action: IAction,
): IEventState => {
  const { payload } = action;

  switch (action.type) {
    case EventsActions.FETCH_EVENTS_LIST_SUCCESS:
    case EventsActions.SAVE_EVENTS:
      return Object.assign({}, state, {
        list: payload,
      });
    case EventsActions.SAVE_SELECTED_EVENTS:
      return Object.assign({}, state, {
        selectedEvents: payload,
      });
    case EventsActions.SAVE_SELECTED_EVENTS_BY_IDS:
      const selectedEvents = filter(state.list, (event) =>
        includes(payload, event.id),
      );

      return Object.assign({}, state, {
        selectedEvents,
        selectedEventIds: payload,
      });
    case EventsActions.SAVE_INCOMPLETE_TRANSFER_EVENTS:
      return Object.assign({}, state, {
        incompleteTransferSelectedEvents: payload,
      });
    case EventsActions.SAVE_TRANSFER_AUTO_POPULATE_EVENT:
      return Object.assign({}, state, <
        Pick<IEventState, 'newTransferAutoPopulateEvent'>
      >{
        newTransferAutoPopulateEvent: {
          ...state.newTransferAutoPopulateEvent,
          [payload.type]: payload.eventId,
        },
      });
    default:
      return state;
  }
};
